import { render, staticRenderFns } from "./DownloadChart.vue?vue&type=template&id=4d40b283&scoped=true&"
import script from "./DownloadChart.vue?vue&type=script&lang=js&"
export * from "./DownloadChart.vue?vue&type=script&lang=js&"
import style0 from "./DownloadChart.vue?vue&type=style&index=0&id=4d40b283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40b283",
  null
  
)

export default component.exports